import { useSelector } from 'react-redux'

import { RootStateTypeExtra } from '@store/types'

import {
  GeneralExternalLinkModelTypes,
  selectFromResult,
  useGetGeneralExternalLinksByStockQuery,
} from '@api/general-external-links'

import { ProjectType } from '@adUtilities/constants/common'

const useGetGeneralExternalLinks = () => {
  const {
    projectName,
    projectType,
    activeBlock,
    activeLevel,
    activePrecinct,
    activeStage,
    blockKeys,
    precinctList,
  } = useSelector((state: RootStateTypeExtra) => ({
    projectName: state.projectIdentity.projectName,
    projectType: state.projectConfig.type,
    activeBlock: state.building.activeBlock,
    activeLevel: state.building.activeLevel,
    activePrecinct: state.houseAndLand.activePrecinctId,
    activeStage: state.houseAndLand.activeStageId,
    blockKeys: Object.keys(state.interactivePlan.blocks),
    precinctList: state.houseAndLand.precinctList,
  }))

  const modelType =
    projectType === ProjectType.HouseAndLand
      ? GeneralExternalLinkModelTypes.STAGE
      : GeneralExternalLinkModelTypes.FLOORPLAN

  const getActiveBlock = () => {
    if (blockKeys.length > 1) {
      return { block: activeBlock }
    }
    return undefined
  }

  const getActivePrecinct = () => {
    if (precinctList.length > 1) {
      return { precinct: activePrecinct }
    }
    return undefined
  }

  const {
    isLoaded,
    isError,
    isFetching,
    generalExternalLinks: fetchedGeneralExternalLinks,
  } = useGetGeneralExternalLinksByStockQuery(
    {
      projectName,
      modelType,
      label: activeLevel || activeStage,
      ...getActiveBlock(),
      ...getActivePrecinct(),
    },
    { selectFromResult }
  )

  if (isFetching) {
    return {
      generalExternalLink: null,
      isLoaded: false,
      isFetching: true,
      isError: false,
    }
  }

  return {
    generalExternalLink: fetchedGeneralExternalLinks?.[0] || null,
    isLoaded,
    isFetching,
    isError,
  }
}

export default useGetGeneralExternalLinks
